module.exports = __webpack_public_path__ + "static/media/johns-manville-logo-color.b2298da8.svg";